<template>
  <main id="queueLine-page">
    <div class="queueLine__content">
      <div class="queueLine__icon icon-circle">
        <span class="di di-icon-message"></span>
      </div>
      <h1>{{ userFirstName }}, mantenha esta página aberta.</h1>
      <p>Em breve você será chamado para finalizar o atendimento em um guichê, favor aguarde.</p>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'QueueLine',
  computed: {
    ...mapGetters('global', ['userFirstName']),
    ...mapState({
      nextPatientQueue: ({ queue }) => queue.data.nextPatientQueue,
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
  },
  watch: {
    /** @description Checks if current patient's cpf is equal to the one being called (queue), retrieves service desk number */
    async nextPatientQueue() {
      if (this.nextPatientQueue.senha?.documento?.valor === this.currentAdmission.patient.cpf) {
        const serviceDeskId = this.nextPatientQueue.senha.guiche;
        await this.getServiceDeskNumber(serviceDeskId).then(() =>
          this.goNextStep('queue_notification'),
        );
      }
    },
  },
  methods: {
    ...mapActions({
      listenNextPatient: 'queueNotificationSubscription',
      getServiceDeskNumber: 'getServiceDesk',
    }),
  },
};
</script>
<style lang="scss">
#queueLine-page {
  .icon-circle {
    width: 88px;
    height: 88px;

    .di-icon-message:before {
      color: var(--color-primary);
      font-size: 45px;
    }
  }

  .queueLine {
    &__content {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 25%;
      align-items: center;

      h1 {
        line-height: 32px;
      }

      p {
        line-height: 24px;
        color: var(--color-grey-6);
        font-weight: 500;
      }

      h1,
      p,
      .queueLine_icon {
        margin-top: 20px;
        text-align: center;
        width: 80%;
      }
    }

    &__icons {
      align-self: flex-start;
      height: fit-content;
    }
  }
}

.queue-line {
  header {
    border-bottom: 1px solid rgba(196, 196, 196, 0.3);

    .header__title {
      color: var(--color-grey-6);
    }
  }

  .container {
    padding: 0;
  }
}
</style>
